import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/logo-3.png';
const _hoisted_1 = {
    class: "bg-[#070F22] py-10 section lg:py-17 w-full"
};
const _hoisted_2 = {
    class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 divide-[#2B344A] divide-x-0 md:divide-x"
};
const _hoisted_3 = {
    class: "pr-0 md:pr-6 lg:pr-39 mb-8 md:mb-0"
};
const _hoisted_4 = {
    class: "text-[#FFFFFFA6] text-sm leading-6 md:text-base md:leading-7 lg:text-[19px] lg:leading-[35px]"
};
const _hoisted_5 = {
    class: "text-[#FFFFFFA6] text-sm leading-6 md:text-base md:leading-7 lg:text-[19px] lg:leading-[35px]"
};
const _hoisted_6 = {
    class: "text-[#FFFFFFA6] text-sm leading-6 md:text-base md:leading-7 lg:text-[19px] lg:leading-[35px]"
};
const _hoisted_7 = {
    class: "text-[#FFFFFFA6] text-sm leading-6 md:text-base md:leading-7 lg:text-[19px] lg:leading-[35px]"
};
const _hoisted_8 = {
    class: "pl-0 md:pl-6 lg:pl-39 col-span-1 md:col-span-1 lg:col-span-2 mt-8 md:mt-0"
};
const _hoisted_9 = {
    class: "grid grid-cols-2 gap-6 md:gap-8 lg:gap-8 h-full"
};
const _hoisted_10 = {
    class: "flex flex-col justify-between"
};
const _hoisted_11 = {
    role: "list",
    class: "mt-3 md:mt-4 lg:mt-6 space-y-2 md:space-y-3 lg:space-y-4"
};
const _hoisted_12 = {
    key: 0,
    class: "text-white text-sm leading-5 md:text-base md:leading-6 lg:text-[19px] lg:leading-[27px] mb-3 md:mb-4 lg:mb-[27px]"
};
const _hoisted_13 = [
    "href"
];
const _hoisted_14 = {
    class: "flex flex-col justify-between"
};
const _hoisted_15 = {
    role: "list",
    class: "mt-3 md:mt-4 lg:mt-6 space-y-2 md:space-y-3 lg:space-y-4"
};
const _hoisted_16 = {
    key: 0,
    class: "text-white text-sm leading-5 md:text-base md:leading-6 lg:text-[19px] lg:leading-[27px] mb-3 md:mb-4 lg:mb-[27px]"
};
const _hoisted_17 = [
    "href"
];
import { navigationDict as navigation } from '@/constant/footer';
export default {
    __name: 'Footer',
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[0] || (_cache[0] = _createElementVNode("div", {
                                class: "aspect-[317/60] h-10 md:h-12 lg:h-15 mb-6 md:mb-8 lg:mb-36"
                            }, [
                                _createElementVNode("img", {
                                    src: _imports_0,
                                    class: "w-full h-full object-cover",
                                    alt: ""
                                })
                            ], -1)),
                            _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(navigation).info.address), 1),
                                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(navigation).info.consultationHotline), 1),
                                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(navigation).info.contact), 1),
                                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(navigation).info.workingHours), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _cache[1] || (_cache[1] = _createElementVNode("h3", {
                                        class: "font-[DOUYINSANSBOLD] text-lg leading-6 md:text-xl md:leading-7 lg:text-[27px] lg:leading-[32px] text-white"
                                    }, " 互联互通 ", -1)),
                                    _createElementVNode("ul", _hoisted_11, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigation).company, (item, i)=>{
                                            return _openBlock(), _createElementBlock("li", {
                                                key: item.name,
                                                class: "mb-3 md:mb-4 lg:mb-[27px] last:mb-0"
                                            }, [
                                                !i ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(item.name), 1)) : (_openBlock(), _createElementBlock("a", {
                                                    key: 1,
                                                    href: item.href,
                                                    target: "_blank",
                                                    class: "text-[#FFFFFFA6] text-sm leading-5 md:text-base md:leading-6 lg:text-[19px] lg:leading-[27px]"
                                                }, _toDisplayString(item.name), 9, _hoisted_13))
                                            ]);
                                        }), 128))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _cache[2] || (_cache[2] = _createElementVNode("h3", {
                                        class: "font-[DOUYINSANSBOLD] text-lg leading-6 md:text-xl md:leading-7 lg:text-[27px] lg:leading-[32px] text-white"
                                    }, null, -1)),
                                    _createElementVNode("ul", _hoisted_15, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigation).legal, (item, i)=>{
                                            return _openBlock(), _createElementBlock("li", {
                                                key: item.name,
                                                class: "mb-3 md:mb-4 lg:mb-[27px] last:mb-0"
                                            }, [
                                                !i ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(item.name), 1)) : (_openBlock(), _createElementBlock("a", {
                                                    key: 1,
                                                    href: item.href,
                                                    target: "_blank",
                                                    class: "text-[#FFFFFFA6] text-sm leading-5 md:text-base md:leading-6 lg:text-[19px] lg:leading-[27px]"
                                                }, _toDisplayString(item.name), 9, _hoisted_17))
                                            ]);
                                        }), 128))
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]);
        };
    }
};
